/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Scroller from "vux/src/components/scroller/index.vue";
import LoadMore from "vux/src/components/load-more/index.vue";
import CheckIcon from "vux/src/components/check-icon/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import UserLogo from '@/components/UserLogo';
import SearchBar from '@/components/SearchBar';
import ScrollerCustomize from './ScrollerCustomize';
export default {
  components: {
    Scroller: Scroller,
    LoadMore: LoadMore,
    CheckIcon: CheckIcon,
    XButton: XButton,
    UserLogo: UserLogo,
    SearchBar: SearchBar,
    ScrollerCustomize: ScrollerCustomize
  },
  props: {
    height: {
      type: Number,
      required: true
    },
    // 是否是两行列表
    size: {
      type: String,
      default: 'normal'
    },
    // 是否显示图片
    showImage: {
      type: Boolean,
      default: false
    },
    circleImage: {
      type: Boolean,
      default: false
    },
    isPx: {
      type: Boolean,
      default: false
    },
    // 是否开启多选框
    check: {
      type: Boolean,
      default: false
    },
    // 多选数量上限 默认为-1不限制
    maxCheck: {
      type: Number,
      default: -1
    },
    total: {
      type: Number
    },
    usePulldown: {
      type: Boolean,
      default: true
    },
    ids: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // 上拉加载配置
      pullupDefaultConfig: {
        content: '上拉加载更多',
        pullUpHeight: 150,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'smy__plugin-pullup-'
      },
      // 下拉刷新配置
      pulldownDefaultConfig: {
        downContent: '下拉刷新',
        upContent: '释放后刷新',
        loadingContent: '正在刷新...',
        clsPrefix: 'smy__plugin-pulldown-'
      },
      noMoreShow: false,
      // 没有更多结果 显示
      noResult: false,
      // 没有数据 显示
      checkList: [],
      // 选中的列表
      checkListMsg: [],
      checkListImg: [],
      // 选中的列表图片信息
      slotsDefaultLength: 0,
      // item数量
      pulldownLoading: false,
      pullupLoading: false
    };
  },
  computed: {
    // rem高度参数转为px
    heightToPx: function heightToPx() {
      // eslint-disable-next-line standard/computed-property-even-spacing
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      var height = this.height;
      console.log(this.$env);
      if (!this.isPx) height = fontSize * height; // 如果开启了多选 需要减去上下距离

      if (this.check) {
        var top = 4.32 * fontSize;
        var bottom = 4 * fontSize;
        height = height - top - bottom;
      }

      return height - (this.$env === 'app' ? 3.5 : 0) * fontSize;
    },
    isCheckAll: function isCheckAll() {
      return this.check ? this.total <= this.checkListMsg.length : false;
    }
  },
  watch: {
    // 无结果显示
    total: function total(val) {
      if (val || val === 0) {
        if (val === 0) {
          if (!this.noResult) this.noResult = true;
        }

        if (val > 0) {
          if (this.noResult) this.noResult = false;
        }
      }
    },
    checkListMsg: function checkListMsg(val, oldVal) {
      var _this = this;

      if (this.check) {
        this.$nextTick(function () {
          if (_this.maxCheck > 0 && _this.checkListMsg.length > _this.maxCheck) {
            _this.$vux.toast.text("\u6700\u591A\u53EF\u9009".concat(_this.maxCheck, "\u4E2A"));

            _this.checkListMsg = oldVal.splice(0, _this.maxCheck);
          }

          _this.$emit('on-check-change', _this.checkListMsg.slice().map(function (item) {
            return item.value;
          }).sort(function (a, b) {
            return a - b;
          }));
        });
      }
    },
    ids: {
      handler: function handler(val) {
        this.checkListMsg = val.slice();
      },
      immediate: true
    }
  },
  methods: {
    // 全选 开关
    isCheckAllChange: function isCheckAllChange() {
      if (this.isCheckAll) {
        // this.checkList = []
        this.checkListMsg = []; // for (let item of this.$slots.default) {
        //   item.componentInstance.isCheck = false
        // }
      } else {
        var _iterator = _createForOfIteratorHelper(this.$slots.default),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.componentInstance.isCheck = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    // 下拉刷新
    onPulldown: function onPulldown() {
      this.pulldownLoading = true;
      this.$emit('on-pulldown-loading');
      this.$refs.scrollerBottom && this.$refs.scrollerBottom.disablePullup();
    },
    // 下拉刷新完成
    donePulldown: function donePulldown() {
      var _this2 = this;

      setTimeout(function () {
        _this2.pulldownLoading = false;
      }, 1000);
      this.$refs.scrollerBottom && this.$refs.scrollerBottom.donePulldown();

      if (this.check) {
        this.$nextTick(function () {
          var defaultSlots = _this2.$slots.default || []; // const list = defaultSlots.map(item => item.componentInstance.value) || []
          // // 刷新后清空选中
          // this.checkList = this.checkList.filter(item => list.indexOf(item) !== -1)
          // 获取item数量

          _this2.slotsDefaultLength = defaultSlots.length;
        });
      }

      this.$refs.scrollerBottom && this.$refs.scrollerBottom.enablePullup();
    },
    // 上拉加载
    onPullup: function onPullup() {
      this.pullupLoading = true;
      this.$emit('on-pullup-loading');
    },
    // 上拉加载完成
    donePullup: function donePullup() {
      var _this3 = this;

      // this.$refs.scrollerBottom.donePullup()
      setTimeout(function () {
        _this3.pullupLoading = false;
      }, 1000);

      if (this.check) {
        // 获取item数量
        this.$nextTick(function () {
          _this3.slotsDefaultLength = _this3.$slots.default ? _this3.$slots.default.length : 0;
        });
      }
    },
    // 开启上拉加载
    enablePullup: function enablePullup() {
      this.$refs.scrollerBottom && this.$refs.scrollerBottom.enablePullup();
      this.noMoreShow = false;
    },
    // 禁用上拉加载
    disablePullup: function disablePullup() {
      this.$refs.scrollerBottom && this.$refs.scrollerBottom.disablePullup();
      this.noMoreShow = true;
    },
    // 初始化状态
    initLoading: function initLoading() {
      this.noResult = false;
      this.noMoreShow = false;
    },
    // 滚动到顶部
    scrollToTop: function scrollToTop() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.scrollerBottom && _this4.$refs.scrollerBottom.reset && _this4.$refs.scrollerBottom.reset({
          top: 0
        });
      });
    },
    clearCheckList: function clearCheckList() {
      this.checkListMsg = [];
    }
  },
  created: function created() {
    if (this.total || this.total === 0) {
      if (this.total === 0) {
        if (!this.noResult) this.noResult = true;
      }

      if (this.total > 0) {
        if (this.noResult) this.noResult = false;
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      _this5.$refs.scrollerBottom && _this5.$refs.scrollerBottom.reset && _this5.$refs.scrollerBottom.reset();

      if (_this5.check) {
        _this5.slotsDefaultLength = _this5.$slots.default ? _this5.$slots.default.length : 0;
      }
    });
  }
};